import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { GlobalProvider } from "./components/context/globalContext";
import PageLanguageLoader from "./components/Loaders/pageLanguageLoader";
import "./i18n";

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={<PageLanguageLoader />}>
      <GlobalProvider>
        <App />
      </GlobalProvider>
    </Suspense>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
